/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
function slider(){
  
//   console.log($(window).width());
  if($(window).width() > 991){
    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      fade: true,
      asNavFor: '.slider-nav',
      prevArrow:'<button type="button" class="slick-prev slick-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
      nextArrow:'<button type="button" class="slick-next slick-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            dots: false
          }
        }
      ]
    });
    $('.slider-nav').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      focusOnSelect: true,
      vertical:true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            dots: false
          }
        }
      ]
    });
  }
}

$(window).resize(function(){
  slider();
});
$(document).ready(function(){
  $('.CartItem__Actions a.update_minus_link').click(function(e){
  	e.preventDefault();
    
    var CartItemActions = $(this).closest('.CartItem__Actions')
    var qty_value = $(CartItemActions).find(".QuantitySelector__CurrentQuantity").val();
    qty_value = parseInt(qty_value) - 1;
    if(qty_value < 0)
      qty_value = 0;
    $(CartItemActions).find(".QuantitySelector__CurrentQuantity").val(qty_value);
    fnCartItemUpdated(CartItemActions);
    
  });
  
  $('.CartItem__Actions a.update_plus_link').click(function(e){
  	e.preventDefault();
    var CartItemActions = $(this).closest('.CartItem__Actions')
    var qty_value = $(CartItemActions).find(".QuantitySelector__CurrentQuantity").val();
    qty_value = parseInt(qty_value) + 1;
    $(CartItemActions).find(".QuantitySelector__CurrentQuantity").val(qty_value);
    fnCartItemUpdated(CartItemActions);
  });
  
  function fnCartItemUpdated(CartItemActions){
  	console.log("QTY changed");
  
  	document.dispatchEvent(new CustomEvent('theme:loading:start'));

    var quantity = $(CartItemActions).find(".QuantitySelector__CurrentQuantity").val();
    var line_id = $(CartItemActions).find(".QuantitySelector__CurrentQuantity").attr('data-line-id');


    fetch('/cart/change.js', {
      body: JSON.stringify({ id: line_id, quantity: quantity }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (cart) {
      console.log(window.theme);
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if(window.theme.template == 'cart')
      	location.href='';
    });
    
  }
  $(".QuantitySelector__CurrentQuantity").change(function(){
  	//console.log("QTY changed");
    
    
    
    
  });
  
  $('[data-fancybox]').fancybox({
    fullScreen : true
  });

  if($('#shopify-section-press-block').length > 0){
    setTimeout(function(){
      var magicGrid;
      if(navigator.userAgent.indexOf('MSIE')===-1 && navigator.appVersion.indexOf('Trident/')===-1) {

        magicGrid = new MagicGrid({
          container: "#press-blocks", // Required. Can be a class, id, or an HTMLElement.
          gutter: 0, // Optional. Space between items. Default: 25(px).
          static: false, // Required for static content. Default: false.
          items: 3, // Required for dynamic content. Initial number of items in the container.
          maxColumns: 3, // Optional. Maximum number of columns. Default: Infinite.
          useMin: true, // Optional. Prioritize shorter columns when positioning items? Default: false.
          useTransform: true, // Optional. Position items using CSS transform? Default: True.
          animate: false, // Optional. Animate item positioning? Default: false.
          center: true, //Optional. Center the grid items? Default: true. 
        });

        magicGrid.listen();

        /*Simplistic.onImagesLoaded($('.press-content .articles-wrapper .magicgridcontainer img'), function(){
          magicGrid.positionItems();
        });*/
      }

      var currentPage = 1;
      var magicgridcontainer = $('.press_block');

      $('.load-more-wrap .load-more').click(function(){
        var button = $(this);
        button.attr('disabled',"disabled");
        var hideButton = true;
        currentPage++;
        $('.loadmore-blocks .about_box').each(function(ix, article){
          if (ix>=9) {
            hideButton = false;
            return false;
          }
          $(article).appendTo(magicgridcontainer);
        });

        if (hideButton){
          button.hide();
        }
        Simplistic.onImagesLoaded($('.press-content .articles-wrapper .magicgridcontainer img'), function(){
          if(navigator.userAgent.indexOf('MSIE')===-1 && navigator.appVersion.indexOf('Trident/')===-1) {
            magicGrid.positionItems();
          }
          initArticles();
        });
        magicGrid.positionItems();
        button.removeAttr('disabled');
      });

      magicGrid.listen();
    }, 2000);
  }
  
  $('.ProductItem .color_swatch_list input').on('change', function(){
    console.log($(this).data('variant-price'));
    $(this).parents('.ProductItem').find('.ProductItem__Price span').text($(this).data('variant-price'));
  });
  
  slider();
  $('.has-sub .Expand-btn').on('click', function(){
    $(this).next('.Sub.Linklist').toggleClass('active');
    $(this).text($(this).text() == '+' ? '-' : '+');
  });
  
  $('.ColorSwatch').on('click',function(){
    var t = $(this).attr('title');
    $(this).parents('.ProductItem__Info').find('.SwatchList-Selected').text(t);
  });
  
  $(".newsletter-popup-btn").fancybox({
    maxWidth	: 800,
    maxHeight	: 600,
    fitToView	: false,
    width		: '70%',
    height		: '70%',
    autoSize	: false,
    closeClick	: false,
    openEffect	: 'none',
    closeEffect	: 'none'
  });
  
  if($.cookie('popup') != 'seen'){
    $.cookie('popup', 'seen', { expires: 30, path: '/' }); // Set it to last a year, for example.
    $(".newsletter-popup-btn").trigger('click');
  }
  
  $('.Linklist > li > .Expand-btn').on('click', function(){
    if($(this).next('.Second-Sub').hasClass('active')){
      $(this).text('-');
    }else{
      $(this).text('+');
    }
  });
  
  $('.Sub .Expand-btn').on('click', function(){
    if($(this).next('.Grand--Sub').hasClass('active')){
      $(this).text('-');
    }else{
      $(this).text('+');
    }
  });
});

$(document).ready(function() {
  if ($(".categories_slider .categories_list").length>0) {
    $(".categories_slider .categories_list").owlCarousel({
      items : 1,
      itemsCustom : false,     
      scrollPerPage: true,
      loop: true,
      slideSpeed: 500,
      stopOnHover: true,   
      itemsDesktop : [1199,1],
      itemsDesktopSmall : [991,1],
      itemsTablet: [767,1],
      itemsTabletSmall: false,
      itemsMobile : [479,1],
      singleItem : true,
      itemsScaleUp : true,
      pagination : false,
      navigation : true,
      navigationText : ["prev","next"]

    });
  }
});

$('.sub_collection_slider .sub_collection_list').owlCarousel({
    loop:true,
    pagination: false,
    navigation : true,
    navigationText : ["prev","next"],
    items: 10,
    itemsDesktop : [1400, 8],
    itemsDesktopSmall : [991,6],
    itemsTablet: [767,4],
    itemsMobile : [479,3],
    marginRight: 26
});

jQuery(document).ready(function() {
  
  jQuery(".heart_share .iWishAdd").click(function(){
    jQuery(".iwishAddWrap .as_wish " ).replaceWith('<svg viewBox="0 -28 512.00002 512" xmlns="http://www.w3.org/2000/svg"><path d="m471.382812 44.578125c-26.503906-28.746094-62.871093-44.578125-102.410156-44.578125-29.554687 0-56.621094 9.34375-80.449218 27.769531-12.023438 9.300781-22.917969 20.679688-32.523438 33.960938-9.601562-13.277344-20.5-24.660157-32.527344-33.960938-23.824218-18.425781-50.890625-27.769531-80.445312-27.769531-39.539063 0-75.910156 15.832031-102.414063 44.578125-26.1875 28.410156-40.613281 67.222656-40.613281 109.292969 0 43.300781 16.136719 82.9375 50.78125 124.742187 30.992188 37.394531 75.535156 75.355469 127.117188 119.3125 17.613281 15.011719 37.578124 32.027344 58.308593 50.152344 5.476563 4.796875 12.503907 7.4375 19.792969 7.4375 7.285156 0 14.316406-2.640625 19.785156-7.429687 20.730469-18.128907 40.707032-35.152344 58.328125-50.171876 51.574219-43.949218 96.117188-81.90625 127.109375-119.304687 34.644532-41.800781 50.777344-81.4375 50.777344-124.742187 0-42.066407-14.425781-80.878907-40.617188-109.289063zm0 0"></path></svg>');
  });
  
   jQuery(".iwishAddWrap .as_wish").click(function(){
   	jQuery(".iwishAddWrap .iWishAdd" ).replaceWith('<svg viewBox="0 -28 512.00002 512" xmlns="http://www.w3.org/2000/svg"><path d="m471.382812 44.578125c-26.503906-28.746094-62.871093-44.578125-102.410156-44.578125-29.554687 0-56.621094 9.34375-80.449218 27.769531-12.023438 9.300781-22.917969 20.679688-32.523438 33.960938-9.601562-13.277344-20.5-24.660157-32.527344-33.960938-23.824218-18.425781-50.890625-27.769531-80.445312-27.769531-39.539063 0-75.910156 15.832031-102.414063 44.578125-26.1875 28.410156-40.613281 67.222656-40.613281 109.292969 0 43.300781 16.136719 82.9375 50.78125 124.742187 30.992188 37.394531 75.535156 75.355469 127.117188 119.3125 17.613281 15.011719 37.578124 32.027344 58.308593 50.152344 5.476563 4.796875 12.503907 7.4375 19.792969 7.4375 7.285156 0 14.316406-2.640625 19.785156-7.429687 20.730469-18.128907 40.707032-35.152344 58.328125-50.171876 51.574219-43.949218 96.117188-81.90625 127.109375-119.304687 34.644532-41.800781 50.777344-81.4375 50.777344-124.742187 0-42.066407-14.425781-80.878907-40.617188-109.289063zm0 0"></path></svg>');
   });
  
	jQuery(".heart_share .iWishAdd").click(function(){
    	location.href="https://sarahchloe.com/apps/iwish"
    });
  	setTimeout(function(){
      if (window.location.href === "https://sarahchloe.com/apps/iwish") {
          jQuery(".iwishShareContainer .iwishShareBtn.iwishEmail").click();
      }
    },5000);
  
});

// CHECKBOX CHECKED AFTER REFRESH
$(function(){
    var checkbox = localStorage.input === 'true'? true: false;
    $('#gift-contain').prop('checked', checkbox || false);
});

$('#gift-contain').on('change', function() {
    localStorage.input = $(this).is(':checked');
    console.log($(this).is(':checked'));
});

jQuery(document).ready(function() {
  $(".cart_drawer_note_group_trigger").click(function() {
    $("#shopify-section-cart-drawer .cart_drawer .cart_drawer_inner").toggleClass("active");
    $(this).toggleClass("active");
  });
});

// HIDE RECENTLY VIEWED GRID
jQuery(document).ready(function() {
  if ($('.recently-viewed-grid').is(':empty')){
    $("#cartDrawerrecentlyviewedInner").addClass("hidden");
  }else{
    $("#cartDrawerrecentlyviewedInner").removeClass("hidden");
  }  
});


// Product Tab

document.addEventListener('DOMContentLoaded', function () {
  const tabBlocks = document.querySelectorAll('.product-tabs');

  tabBlocks.forEach(block => {
    const buttons = block.querySelectorAll('.tab-button');
    const contents = block.querySelectorAll('.tab-content');

    // ✅ Activate first tab and content by default
    if (buttons.length > 0 && contents.length > 0) {
      buttons[0].classList.add('active');
      const firstTab = buttons[0].getAttribute('data-tab');
      const firstContent = block.querySelector(`#${firstTab}`);
      if (firstContent) firstContent.classList.add('active');
    }

    // ✅ Setup click events
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const tab = button.getAttribute('data-tab');

        buttons.forEach(btn => btn.classList.remove('active'));
        contents.forEach(content => content.classList.remove('active'));

        button.classList.add('active');
        const contentToShow = block.querySelector(`#${tab}`);
        if (contentToShow) contentToShow.classList.add('active');
      });
    });
  });
});


